import supabase from "../../../supabaseClient.js";

export interface UpdatePrivacyStatusResult {
  success: boolean;
  error: string | null;
}

/**
 * Updates the privacy status of a post in Supabase
 * @param postId - The ID of the post to update
 * @param privacyStatus - The new privacy status ("public", "church_members", "elders", "me_only")
 * @returns Promise with success status and error message if any
 */
export async function updatePostPrivacyStatus(
  postId: string | number,
  privacyStatus: string
): Promise<UpdatePrivacyStatusResult> {
  try {
    if (!postId) {
      return { success: false, error: "Post ID is required" };
    }

    if (!privacyStatus) {
      return { success: false, error: "Privacy status is required" };
    }

    // Validate privacy status
    const validStatuses = ["public", "church_members", "elders", "me_only"];
    if (!validStatuses.includes(privacyStatus)) {
      return {
        success: false,
        error: `Invalid privacy status. Must be one of: ${validStatuses.join(
          ", "
        )}`,
      };
    }

    console.log(
      `Axios - Updating post ${postId} privacy status to: ${privacyStatus}`
    );

    const { data, error } = await supabase
      .from("posts")
      .update({ PrivacyStatus: privacyStatus })
      .eq("id", postId)
      .select();

    if (error) {
      console.error("Axios - Error updating privacy status:", error);
      return { success: false, error: error.message };
    }

    console.log("Axios - Privacy status updated successfully:", data);
    return { success: true, error: null };
  } catch (error) {
    console.error("Axios - Exception updating privacy status:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error",
    };
  }
}
